import React, { useState, useEffect, useCallback } from "react";

import AuthService from "../../../../class/services/AuthService";

import UserService from "../../../../class/User/UserService";
import UserServices from "../../../../class/User_copy/UserService";

import ModalCouponSport from "../../modal/modal_coupon_sport.js";

import { useTranslation } from "react-i18next";

const Bet_history_cupon = () => {
    const { t } = useTranslation();

    const [coupons, setCoupons] = useState([]);
    const [selectedCouponCode, setSelectedCouponCode] = useState("");
    const [selectedCouponId, setselectedCouponId] = useState("");
    const user_id = AuthService.getCustom("user_id");
    const currency = AuthService.getCustom("currency");
    const [status, setStatus] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [filter_by, setFilter_by] = useState("1 Month Ago");

    const [loading, setLoading] = useState(false);

    const [isCustomOpen, setIsCustomOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("all");

    const [resetEnabled, setresetEnabled] = useState(false);

    const [showModal, setShowModal] = useState(false);

    const formatCurrency = (amount, currencyCode) => {
        return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: currencyCode
        }).format(amount);
    };

    const handleOpenModal = (couponCode, id) => {
        setSelectedCouponCode(couponCode);
        setselectedCouponId(id);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedCouponCode("");
        setselectedCouponId("");
    };

    const handleDateFilterChange = (event) => {
        const filter = event.target.value;
        const now = new Date();
        let start, end;

        if (filter === "1week") {
            // Start 7 days ago
            start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            // End exactly one week from the start date
            end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);
            setFilter_by("1 Week Ago");
        } else if (filter === "2weeks") {
            // Start 14 days ago
            start = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
            // End exactly two weeks from the start date
            end = new Date(start.getTime() + 13 * 24 * 60 * 60 * 1000);
            setFilter_by("2 Weeks Ago");
        } else if (filter === "1month") {
            // Set to the first day of the previous month
            start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            // Set to the last day of the previous month
            end = new Date(now.getFullYear(), now.getMonth(), 0);
            setFilter_by(" 1 Month Ago");
        } else if (filter === "custom") {
            // Clear start and end dates for custom
            start = "";
            end = "";
        }

        setresetEnabled(true);

        // Set the start to the beginning of the start day and end to the end of the end day
        if (start) start.setHours(0, 0, 0, 0);
        if (end) end.setHours(23, 59, 59, 999);

        // Convert start and end to Unix timestamps
        setStartDate(start ? Math.floor(start.getTime() / 1000) : "");
        setEndDate(end ? Math.floor(end.getTime() / 1000) : "");

        setCurrentPage(1);
        setCoupons([]);
        setHasMore(true);
    };

    const handleCustomDateChange = (event) => {
        const { name, value } = event.target;
        const date = new Date(value).getTime() / 1000;
        setFilter_by("Custom");
        if (name === "start") {
            setStartDate(date);
        } else {
            setEndDate(date);
        }
    };

    const loadCoupons = async (page) => {
        setLoading(true);
        try {
            const data = await UserServices.getCupon(
                user_id,
                currency,
                status,
                startDate,
                endDate,
                page,
                10,
            );

            // console.log("Fetched coupons data:", data);

            if (data.status == "ok" && data.params.count > 0) {
                setCoupons((prevCoupons) =>
                    page === 1
                        ? data.params.coupons
                        : [...prevCoupons, ...data.params.coupons],
                );
                setHasMore(data.params.coupons.length === 10); // Assume more data if we received a full page
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCoupons(currentPage);
    }, [startDate, endDate, currentPage]);

    const handleScroll = useCallback(() => {
        if (
            window.innerHeight + document.documentElement.scrollTop + 100 >=
                document.documentElement.scrollHeight &&
            hasMore
        ) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    }, [hasMore]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    useEffect(() => {
        const fetchCoupons = async () => {
            setLoading(true);
            try {

                const data = await UserServices.getCupon(
                    user_id,
                    currency,
                    status,
                    startDate,
                    endDate,
                    1,
                    10,
                );
                // console.log(data);

                if (data.status == "ok" && data.params.count > 0) {
                    setCoupons(data.params.coupons);
                } else {
                    setCoupons([]);
                }
            } catch (error) {
                console.error("Error fetching coupons:", error);
            }finally{
                setLoading(false);
            }
        };

        fetchCoupons();
    }, [user_id, currency, status, startDate, endDate,currentPage]);

    const formatDateTime = (timestamp) => {
        const date = new Date(timestamp * 1000);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case "L":
                return "lose";
            case "W":
                return "win";
            case "P":
                return "pending";
            case "N":
                return "pending";
            case "CASH":
                return "cashout"
            default:
                return "Unknown";
        }
    };

    const getStatusTranslation = (status) => {
        switch (status) {
            case "L":
                return t("Lose");
            case "W":
                return t("Win");
            case "P":
                return t("Pending");
            case "N":
                return t("Pending");
            case "CASH":
                return t("Cashout")
            default:
                return t("Unknown");
        }
    };

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
        setCurrentPage(1);
        setCoupons([]);
        setHasMore(true);
    };

    const handleReset = () => {
        setStatus("");
        setFilter_by("");
        setStartDate("");
        setresetEnabled(false);
        setEndDate("");
        setCurrentPage(1);
        setCoupons([]);
        setHasMore(true);
    };

    return (
        <div>
            <div
                className="tab-pane fade show active"
                id="sport-tab-pane"
                role="tabpanel"
                aria-labelledby="sporte-tab"
                tabIndex="0"
            >
                <div className="form-online">
                    <section className="forms boxed-form">
                        <div className="form signup">
                            <div className="form-content">
                                <div className="header-form-content">
                                    <h3>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            id="Livello_1"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 1005.7 1005.7"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 1005.7 1005.7",
                                            }}
                                            xmlSpace="preserve"
                                        >
                                            <g>
                                                <path d="M338.3,1005.7c-13.3,0-26.8-4.5-38.1-13.1c-14.7-11.1-23.9-27.3-25.2-44.4c-1-13.6,1.6-26.4,8.2-39.2 c61.3-120.1,110.7-217.2,155.6-305.6c1.6-3.2,2.6-6.8,2.5-9.3c0-0.2,0-0.3,0-0.3c-0.1-0.2-1.2-1.2-3.8-1.7 c-1.2-0.2-2.9,0.5-3.9,2.3c-5.4,10.3-10.8,20.9-16,31.2c-2.3,4.6-4.6,9.1-6.9,13.6c-7.7,15.2-15.5,30.4-23.2,45.6 c-18.8,37-38.3,75.3-57.6,112.9c-8,15.6-20.9,27.4-36.1,33.1c-15.3,5.7-32.4,5.2-48.2-1.6c-14.4-6.2-26.4-18.3-32.9-33.2 c-6.7-15.4-7-32.5-0.8-46.9c6.9-16.2,15-31.9,22.9-47.1c2.2-4.3,4.4-8.6,6.6-12.9c47.8-93.8,95.7-187.6,143.5-281.4l54.3-106.4 c-12.9,0.3-25.8,0.7-38.5,1.1l-13,0.4c-10.4,0.3-20.8,0.7-31.2,1c-23.8,0.8-48.4,1.7-72.7,2c-24,0.4-43.6-11.8-53.5-33.5 c-10.1-21.9-6.8-44.2,9.3-62.9c9.6-11.1,22.5-17.7,36.3-18.6c20.5-1.3,40.7-2,56.1-2.5c24.6-0.8,49.7-1.5,73.9-2.1 c5.3-0.1,10.6-0.3,15.9-0.4l0-0.2l14.6-0.4c12.9-0.4,25.7-0.7,38.6-1.1c30.1-0.8,61.2-1.6,91.8-2.8c28.5-1.1,54.6,4.7,77.3,17.4 c6.1,3.4,12.2,6.8,18.3,10.1c30.6,17,62.3,34.5,92.9,53c40.1,24.3,70.7,59.9,90.7,105.7c14.8,33.7,21.4,69,19.8,105 C864,511.8,853,549.2,833,583.7c-13.7,23.7-42.4,34.7-68.3,26.2c-25.9-8.5-42.4-34.1-39.4-60.9c1.1-10,5.2-19,8.4-24.7 c27-48.3,20.3-105.5-17.3-145.7c-3.8-4.1-8.3-7.9-13-11.7c-7.5,14.7-15.1,29.6-22.5,44l-59.5,116.8 c-73.1,143.5-148.8,292-223.1,438c-11,21.7-26.8,34.4-48.2,38.9C346.2,1005.3,342.3,1005.7,338.3,1005.7z M437,562.6 c2,0,4.1,0.2,6.1,0.6c16.4,3.2,27.2,15.1,27.6,30.2c0.2,7.4-1.8,15.7-5.7,23.4c-44.8,88.4-94.3,185.5-155.6,305.6 c-4.1,8-5.7,15.5-5.1,23.6c0.7,8.7,5.6,17.2,13.5,23.1c8,6,17.5,8.4,26.2,6.6c12.4-2.6,21.1-9.8,28-23.4 c74.3-146,150-294.4,223.1-438l59.5-116.8c8.2-16,16.6-32.6,25-48.9c5.1-10,12.1-13.4,17.1-14.5c6.5-1.4,13.2,0.3,18.9,4.8l0.7,0.6 c7.3,5.8,14.9,11.7,21.7,19c46.4,49.8,54.8,120.5,21.4,180.2c-2.7,4.7-4.4,9.6-4.8,13.6c-1.4,12.8,6.9,25.5,19.3,29.6 c12.5,4.1,26.9-1.5,33.5-13c17.6-30.4,27.3-63.3,28.8-97.7c1.4-31.4-4.4-62.3-17.4-91.8c-17.6-40.1-44.2-71.2-79-92.3 c-30.1-18.2-61.5-35.6-91.9-52.4c-6.1-3.4-12.2-6.8-18.3-10.2c-18.2-10.1-38.4-14.6-61.8-13.7c-30.8,1.2-62,2-92.2,2.8 c-8,0.2-16,0.4-23.9,0.6l0,0.2l-14.6,0.4c-10.2,0.3-20.4,0.6-30.5,0.8c-24.2,0.7-49.2,1.3-73.7,2.1c-15.1,0.5-35.1,1.2-55.2,2.5 c-7.5,0.5-12.8,4.9-15.9,8.4c-8.5,9.8-10.1,20.1-4.9,31.3c5.2,11.2,13.8,16.5,26.3,16.3c24-0.4,48.5-1.2,72.2-2 c10.4-0.4,20.9-0.7,31.3-1l12.9-0.4c16.1-0.5,32.8-1,49.3-1.4c7.9-0.2,14.9,3.1,19.3,8.9c4.4,5.9,5.6,13.6,3.3,21.3 c-0.8,2.7-2,4.9-2.9,6.5c-0.2,0.3-0.4,0.7-0.5,1L411,421.1c-47.9,93.8-95.7,187.6-143.5,281.4c-2.2,4.4-4.5,8.7-6.7,13.1 c-7.6,14.7-15.5,29.9-22,45.1c-6.4,14.9,2.3,34.6,18.3,41.5c18.2,7.8,36.9,0.6,46.5-17.9c19.3-37.5,38.8-75.8,57.6-112.7 c7.7-15.2,15.5-30.4,23.2-45.6c2.3-4.5,4.6-9,6.9-13.6c5.3-10.4,10.7-21.1,16.2-31.7C413.4,569.5,425,562.6,437,562.6z" />
                                            </g>
                                            <g>
                                                <path d="M649.2,951.8c-26.2,0-51.1-10.4-70-29.2c-19.3-19.2-29.9-44.7-29.9-71.8c0-26.7,10.5-51.8,29.6-70.8 c18.9-18.9,43.9-29.2,70.4-29.2c0.1,0,0.2,0,0.4,0c55.1,0.2,99.9,45.3,99.8,100.5l0,0c-0.1,55.2-44.9,100.4-99.9,100.6 C649.4,951.8,649.3,951.8,649.2,951.8z M649.3,780.3c-18.6,0-36.3,7.3-49.6,20.6c-13.5,13.4-20.9,31.1-20.9,49.9 c0,19.2,7.5,37.2,21.2,50.9c13.4,13.3,30.8,20.6,49.2,20.6c0.1,0,0.2,0,0.3,0c38.8-0.2,70.5-32.1,70.5-71.2 c0.1-39-31.5-70.8-70.5-70.9C649.5,780.3,649.4,780.3,649.3,780.3z" />
                                            </g>
                                            <g>
                                                <path d="M658.1,193.3C658.1,193.3,658.1,193.3,658.1,193.3c-25.8,0-49.9-10-68-28.2c-18.3-18.4-28.3-43.1-28.2-69.4 c0.1-25.6,10.4-49.8,29-68.1C609.4,9.6,633.5-0.3,658.8,0c52.9,0.6,95.8,44,95.7,96.8v0c-0.1,25.9-10.1,50.2-28.2,68.3 C708.1,183.3,683.9,193.3,658.1,193.3z M657.8,29.5c-17.2,0-33.5,6.8-46.2,19.2c-12.9,12.7-20.1,29.5-20.2,47.2 c-0.1,18.4,6.9,35.6,19.6,48.4c12.5,12.6,29.2,19.5,47,19.5c0,0,0,0,0,0c17.9,0,34.7-6.9,47.3-19.6c12.6-12.6,19.6-29.5,19.6-47.6 c0.1-36.7-29.7-66.8-66.5-67.2C658.2,29.5,658,29.5,657.8,29.5z" />
                                            </g>
                                        </svg>

                                        {t("Sport_Coupon")}
                                    </h3>
                                    <div className="select_filter">
                                        {resetEnabled && (
                                            <a
                                                className="reset-d-btn"
                                                onClick={handleReset}
                                            >
                                                <svg
                                                    viewBox="0 0 1920 1920"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" />
                                                </svg>
                                            </a>
                                        )}

                                        <div className="drop_dash dropdown">
                                            <a
                                                className="dropdown-toggle no-arrow"
                                                href="#"
                                                id="navbarDropdown"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <span id="selectedTitleDateSport">
                                                    {filter_by}
                                                </span>

                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 45.402 45.402"
                                                    xmlSpace="preserve"
                                                >
                                                    <path d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27                                  c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435                                  c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z" />
                                                </svg>
                                            </a>

                                            <div
                                                className="dropdown-menu dropdown-menu-end filter-section"
                                                aria-labelledby="navbarDropdown"
                                            >
                                                <div className="radio-group">
                                                    <input
                                                        id="1weekSelectSport"
                                                        type="radio"
                                                        name="radio-group-sport"
                                                        className="radio-input"
                                                        autoComplete="off"
                                                        value="1week"
                                                        onChange={
                                                            handleDateFilterChange
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="1weekSelectSport"
                                                        className="radio-label"
                                                    >
                                                        <span className="radio-inner-circle"></span>
                                                        {t("1_Week_Ago")}{" "}
                                                    </label>

                                                    <input
                                                        id="2weekSelectSport"
                                                        type="radio"
                                                        name="radio-group-sport"
                                                        className="radio-input"
                                                        autoComplete="off"
                                                        value="2weeks"
                                                        onChange={
                                                            handleDateFilterChange
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="2weekSelectSport"
                                                        className="radio-label"
                                                    >
                                                        <span className="radio-inner-circle"></span>
                                                        {t("2_Week_Ago")}{" "}
                                                    </label>

                                                    <input
                                                        id="1monthSelectSport"
                                                        type="radio"
                                                        name="radio-group-sport"
                                                        className="radio-input"
                                                        autoComplete="off"
                                                        value="1month"
                                                        onChange={
                                                            handleDateFilterChange
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="1monthSelectSport"
                                                        className="radio-label"
                                                    >
                                                        <span className="radio-inner-circle"></span>
                                                        {t("1_Month_Ago")}{" "}
                                                    </label>
                                                </div>

                                                {true && (
                                                    <div className="input-group input-daterange">
                                                        <input
                                                            type="date"
                                                            name="start"
                                                            className="form-control date_start_sport"
                                                            onChange={
                                                                handleCustomDateChange
                                                            }
                                                        />
                                                        <div className="input-group-text">
                                                            to
                                                        </div>
                                                        <input
                                                            type="date"
                                                            name="end"
                                                            className="form-control date_end_sport"
                                                            onChange={
                                                                handleCustomDateChange
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="radio2">
                                    <input
                                        label={t("All")}
                                        type="radio"
                                        name="data_type_change"
                                        value=""
                                        checked={status === ""}
                                        onChange={handleStatusChange}
                                    />
                                    <input
                                        label={t("Win")}
                                        type="radio"
                                        name="data_type_change"
                                        value="W"
                                        checked={status === "W"}
                                        onChange={handleStatusChange}
                                    />
                                    <input
                                        label={t("Pending")}
                                        type="radio"
                                        name="data_type_change"
                                        value="N"
                                        checked={status === "N"}
                                        onChange={handleStatusChange}
                                    />
                                    <input
                                        label={t("Lose")}
                                        type="radio"
                                        name="data_type_change"
                                        value="L"
                                        checked={status === "L"}
                                        onChange={handleStatusChange}
                                    />
                                </div>

                                {coupons.length > 0 ? (
                                    coupons.map((coupon) => (
                                        <div
                                            key={coupon.id}
                                            className="coupon-box"
                                        >
                                            <div className="row-coupon">
                                                <h3>
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        {/* SVG path */}
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M3.75 6.75L4.5 6H20.25L21 6.75V10.7812H20.25C19.5769 10.7812 19.0312 11.3269 19.0312 12C19.0312 12.6731 19.5769 13.2188 20.25 13.2188H21V17.25L20.25 18L4.5 18L3.75 17.25V13.2188H4.5C5.1731 13.2188 5.71875 12.6731 5.71875 12C5.71875 11.3269 5.1731 10.7812 4.5 10.7812H3.75V6.75ZM5.25 7.5V9.38602C6.38677 9.71157 7.21875 10.7586 7.21875 12C7.21875 13.2414 6.38677 14.2884 5.25 14.614V16.5L9 16.5L9 7.5H5.25ZM10.5 7.5V16.5L19.5 16.5V14.614C18.3632 14.2884 17.5312 13.2414 17.5312 12C17.5312 10.7586 18.3632 9.71157 19.5 9.38602V7.5H10.5Z"
                                                        />
                                                    </svg>
                                                    {coupon.ticketcode}{" "}
                                                    <span
                                                        className={`coupon-status ${getStatusLabel(coupon["is_cashout"] == 1 ? "CASH" : coupon.ticketstatus)}`}
                                                    ></span>
                                                </h3>

                                                <a
                                                    onClick={() =>
                                                        handleOpenModal(
                                                            coupon.ticketcode,
                                                            coupon.ticketid,
                                                        )
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <svg
                                                        viewBox="0 0 14 14"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        aria-hidden="true"
                                                        role="img"
                                                    >
                                                        <path d="M10.027 8.624c.033.025.064.053.094.083l2.829 2.829a1 1 0 01-1.414 1.414L8.707 10.12a1.01 1.01 0 01-.083-.094 5.5 5.5 0 111.403-1.403zM5.5 9a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="row-coupon">
                                                <p>
                                                    {formatDateTime(
                                                        coupon.addedTime,
                                                    )}
                                                </p>
                                                <p className="bet">
                                                    {currency}{" "}
                                                    {coupon.ticketbet} 
                                                    {coupon.ticketstatus != "L" && 
                                                    <span
                                                            className={` ${getStatusLabel(coupon["is_cashout"] == 1 ? "CASH" : coupon.ticketstatus)}`}
                                                    >
                                                            /{" "}{coupon.ticketwin}{" "}
                                                        {getStatusTranslation(
                                                            coupon["is_cashout"] == 1 ? "CASH" : coupon.ticketstatus,
                                                        )}
                                                    </span>
                                                    }

                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : loading ? (
                                    <div className="content-loader-games">
                                        <div className="loader-spinner"></div>
                                        <p>{t("loading")}</p>
                                    </div>
                                ) : (
                                    <div className="no-content-search">
                                        <p>
                                            {t(
                                                "No_results_found_for_your_query."
                                            )}
                                        </p>
                                    </div>
                                )}

                                <ModalCouponSport
                                    showModal={showModal}
                                    closeModal={closeModal}
                                    couponCode={selectedCouponCode}
                                    couponId={selectedCouponId}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Bet_history_cupon;
